import { BrowserRouter } from 'react-router-dom';
import { AppRoutes } from './router';
import { AuthProvider } from './contexts/AuthContext';
import WhatsAppButton from './components/feature/WhatsAppButton';

function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <AuthProvider>
        <AppRoutes />
        <WhatsAppButton />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
